export const styles = {
    container: {
        position: 'relative'
    },
    popperCard: {
        zIndex: 1400
    }
};
